<div class="main">
<app-handover-detail-location-status [handover]="handover" [handoverRelation]="handoverRelation" [readOnlyContent]="readOnlyContent" (sectionTouched)="onSectionTouched($event)" (hasPendingChanges)="emitPendingChanges($event)">
</app-handover-detail-location-status>
<app-handover-detail-location-images [handover]="handover" [handoverRelation]="handoverRelation" [readOnlyContent]="readOnlyContent" >
</app-handover-detail-location-images>
<app-handover-detail-location-wellhead-images [handover]="handover" [handoverRelation]="handoverRelation" [readOnlyContent]="readOnlyContent" >
</app-handover-detail-location-wellhead-images>
</div>